export enum UserTab {
  Profile = "profile",
  Permissions = "permissions",
  Notifications = "notifications",
  Api = "api",
}
